import React from 'react';
import { Link } from 'react-router-dom';
import './AdminSidebar.css';

const AdminSidebar = ({ 
  user, 
  onLogout, 
  activeTab, 
  sidebarCollapsed,
  setSidebarCollapsed 
}) => {
  const menuItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: '📊',
      path: '/admin/dashboard'
    },
    {
      id: 'users',
      label: 'Users Management',
      icon: '👥',
      path: '/admin/users'
    },
  ];

  return (
    <div className={`admin-sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
      {/* Sidebar Header */}
      <div className="sidebar-header">
        {!sidebarCollapsed && (
          <div className="sidebar-logo">
            <span className="logo-icon">🚀</span>
            <span className="logo-text">HR Copilot</span>
          </div>
        )}
        
        <button 
          className="collapse-toggle"
          onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
          title={sidebarCollapsed ? 'Expand' : 'Collapse'}
        >
          {sidebarCollapsed ? '➡️' : '⬅️'}
        </button>
      </div>

      {/* Sidebar Menu */}
      <div className="sidebar-menu">
        {menuItems.map((item) => (
          <Link
            key={item.id}
            to={item.path}
            className={`menu-item ${activeTab === item.id ? 'active' : ''}`}
            title={sidebarCollapsed ? item.label : ''}
          >
            <span className="menu-icon">{item.icon}</span>
            {!sidebarCollapsed && (
              <>
                <span className="menu-text">{item.label}</span>
                {item.id === 'users' && <span className="menu-badge"></span>}
              </>
            )}
          </Link>
        ))}
      </div>

      {/* Sidebar Footer */}
      {!sidebarCollapsed && (
        <div className="sidebar-footer">
          {/* <div className="user-info">
            <div className="user-avatar">
              {user?.email?.charAt(0).toUpperCase() || 'A'}
            </div>
            <div className="user-details">
              <div className="user-name">{user?.name || user?.email || 'Admin'}</div>
              <div className="user-role">{user?.role || 'Administrator'}</div>
            </div>
          </div> */}
          <button onClick={onLogout} className="logout-btn">
            <span className="logout-icon">🚪</span>
            Logout
          </button>
        </div>
      )}

      {sidebarCollapsed && (
        <div className="sidebar-footer-collapsed">
          <button onClick={onLogout} className="logout-btn-collapsed" title="Logout">
            <span className="logout-icon">🚪</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminSidebar;